/* @ngInject */
const labels = () => {
  const self = {}

  self.fields = {
    owner: {
      text: 'Propriétaire à facturer',
    },
    dateBegin: {
      text: 'Depuis',
    },
    dateEnd: {
      text: 'Jusqu\'à',
    },
    provisionCost: {
      text: 'Coût de la mise à disposition (€)',
    },
    unparkCost: {
      text: 'Coût du dégarage (€)',
    },
    linearMeterCost: {
      text: 'Coût du mètre linéaire (€)',
    },
    fixedPartCost: {
      text: 'Coût de la part fixe (€)',
    },
    wagonCost: {
      text: 'Coût du wagon (€)',
    },
    limitWagonLength: {
      text: 'Limite de longueur des wagons (m)',
    },
    fixedPartLength: {
      text: 'Longueur de la part fixe (m)',
    },
  }

  self.log = {

  }

  return self
}

export default labels



// WEBPACK FOOTER //
// ./public/javascript/sygem/invoicing/resources/labels.resource.js